import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FavouriteButton } from 'widgets/player-awards-tracker/js/common/FavouriteButton';
import { getTranslation } from 'common/react/utils/translations';
import { leaderboardFilterSelector } from 'common/store/modules/player-awards/leaderboard/selectors';
import { PlayerPhoto } from 'common/react/components/PlayerPhoto';
import { composeFiltersString } from '../PlayerCell';
import { useTeamsList } from '../../utils';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import { setPlayerModal } from 'common/store/modules/player-awards/player-modal';

export const MobilePlayerCell = ({
    player,
    onPlayerFavouriteClick,
    favourites,
    seasonPid,
    cellProps,
    shouldHidePredicted,
    isBrownlowV2,
    count,
    status
}) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const query = useSelector(leaderboardFilterSelector);

    const compAbbr = PULSE.app.common.match.getCompAbbr(seasonPid);
    const teamsList = useTeamsList(nav?.season.id);

    const teams = [
        { id: -1, name: getTranslation('label.stats.allClubs') },
        ...teamsList.sort((a, b) => a.name.localeCompare(b.name))
    ];
    const seasons = nav?.seasons;

    // Activate the player modal
    const activatePlayerModal = (event) => {
        if (
            event.keyCode &&
            event.keyCode !== PULSE.app.common.CONSTANTS.KEY_CODES.ENTER &&
            event.keyCode !== PULSE.app.common.CONSTANTS.KEY_CODES.SPACE
        ) {
            return;
        }

        dispatch(
            setPlayerModal({
                visible: true,
                playerId: player.playerId,
                team: player?.team,
                seasonPid: seasonPid,
                seasonId: nav.season.id,
                player,
                shouldHidePredicted: shouldHidePredicted,
                isPredictor: isBrownlowV2
            })
        );

        PULSE.app.tracking.recordEvent(
            PULSE.app.common.CONSTANTS.TRACKING.EVENTS.MODAL.VIEW,
            {
                eventData: {
                    /* eslint-disable-next-line camelcase */
                    modal_name: getTranslation(
                        'label.brownlow.tracker.leaderboard.full'
                    )
                }
            }
        );

        if (query.query.length) {
            PULSE.app.analytics.playerSelectionTracking(
                query.query,
                '',
                'Brownlow tracker',
                `${player.givenName} ${player.surname}`,
                count,
                composeFiltersString(nav, teams, seasons)
            );
        }
    };

    return (
        <div {...cellProps} className={`stats-table__row-header-cell `}>
            <div
                className="stats-table__row-brownlow-player-cell"
                role="rowheader"
                scope="row"
            >
                <FavouriteButton
                    player={player}
                    onPlayerFavouriteClick={onPlayerFavouriteClick}
                    favourites={favourites}
                />

                <PlayerPhoto
                    className="stats-leaders-table-player__headshot"
                    photoUrl={player?.photoURL}
                    alt={`${getTranslation('label.stats.headshot.alt')}`}
                    width="1"
                    height="1"
                />

                <div>
                    <button
                        onClick={(event) => activatePlayerModal(event)}
                        onKeyDown={(event) => activatePlayerModal(event)}
                        className="stats-table__row-brownlow-player-name"
                    >
                        <p>{player.givenName}</p>
                        <p>{player.surname}</p>
                    </button>

                    {!player.eligible && (
                        <span className="stats-table__row-brownlow-ineligible">
                            {getTranslation(
                                'label.brownlow.predictor.ineligible'
                            )}
                        </span>
                    )}
                </div>

                {status &&
                    status ===
                        PULSE.app.common.CONSTANTS.MATCH_STATUS.CONCLUDED &&
                    player.winner && (
                        <img
                            className="stats-table__player-cell-brownlow-badge"
                            src={`/resources/${
                                window.RESOURCES_VERSION
                            }/i/elements/${
                                compAbbr === 'AFLW'
                                    ? 'bandf-medal-gold.svg'
                                    : 'brownlow-gold.svg'
                            }`}
                        />
                    )}
            </div>
        </div>
    );
};

MobilePlayerCell.propTypes = {
    player: PropTypes.object.isRequired,
    onPlayerFavouriteClick: PropTypes.func,
    favourites: PropTypes.array,
    seasonPid: PropTypes.string,
    cellProps: PropTypes.any,
    shouldHidePredicted: PropTypes.any,
    isBrownlowV2: PropTypes.bool,
    count: PropTypes.number,
    status: PropTypes.string
};
